import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37be690e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = {
  key: 0,
  class: "right-side"
}
const _hoisted_4 = { class: "right-side-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Anmelden", -1))
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "E-Mail-Adresse", -1))
const _hoisted_9 = {
  key: 0,
  class: "otp-error"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "otp-hint" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "otp" }, "Anmeldecode", -1))
const _hoisted_15 = {
  key: 0,
  class: "otp-error"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

import { ref, computed, nextTick, onUnmounted } from 'vue';
import { useStore } from '@/store';
import UserForm from '@/components/UserForm.vue';
import LeftSide from '@/components/Login/LeftSide.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();
const getUserSession = computed(() => store.getters.getUserSession);
const getUser = computed(() => store.getters.getUser);

const step = ref<'email' | 'otp'>('email');
const email = ref('');
const otpCode = ref('');
const loading = ref(false);
const error = ref('');
const resendCooldown = ref(0);
const otpInputRef = ref<HTMLInputElement | null>(null);
let cooldownTimer: ReturnType<typeof setInterval> | null = null;

const maskedEmail = computed(() => {
  const [user, domain] = email.value.split('@');
  if (!user || !domain) return email.value;
  return `${user.slice(0, 2)}***@${domain}`;
});

async function handleRequestOtp() {
  if (loading.value) return; // Doppel-Submit verhindern (sonst zwei OTP-Mails)
  loading.value = true;
  error.value = '';
  try {
    await store.dispatch('requestOtp', email.value);
    step.value = 'otp';
    startResendCooldown();
    await nextTick();
    otpInputRef.value?.focus();
  } catch (err: any) {
    error.value = mapError(err);
  } finally {
    loading.value = false;
  }
}

async function handleVerifyOtp() {
  if (loading.value) return; // Doppel-Submit verhindern (doppelte Falschantwort löst neue Mail aus)
  loading.value = true;
  error.value = '';
  try {
    const result = await store.dispatch('verifyOtp', otpCode.value);
    if (!result?.signInUserSession) {
      error.value = 'Der Code ist ungültig. Bitte versuchen Sie es erneut.';
    }
    // On success the Amplify Hub fires 'signIn' → router handles redirect
  } catch (err: any) {
    error.value = mapError(err);
  } finally {
    loading.value = false;
  }
}

async function handleResend() {
  if (loading.value || resendCooldown.value > 0) return; // Doppel-Anforderung verhindern
  otpCode.value = '';
  loading.value = true;
  error.value = '';
  try {
    await store.dispatch('requestOtp', email.value);
    startResendCooldown();
    await nextTick();
    otpInputRef.value?.focus();
  } catch (err: any) {
    error.value = mapError(err);
  } finally {
    loading.value = false;
  }
}

function startResendCooldown() {
  resendCooldown.value = 60;
  if (cooldownTimer) clearInterval(cooldownTimer);
  cooldownTimer = setInterval(() => {
    resendCooldown.value -= 1;
    if (resendCooldown.value <= 0 && cooldownTimer) clearInterval(cooldownTimer);
  }, 1000);
}

function mapError(err: any): string {
  const code = err?.code ?? '';
  if (code === 'UserNotFoundException') return 'Diese E-Mail-Adresse ist nicht registriert.';
  if (code === 'NotAuthorizedException') return 'Zu viele Fehlversuche. Bitte fordern Sie einen neuen Code an.';
  return err?.message || 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
}

onUnmounted(() => {
  if (cooldownTimer) clearInterval(cooldownTimer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LeftSide),
      (!_unref(getUserSession))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (step.value === 'email')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 0,
                    class: "otp-form",
                    onSubmit: _withModifiers(handleRequestOtp, ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        id: "email",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                        type: "email",
                        autocomplete: "email",
                        placeholder: "name@einrichtung.de",
                        required: ""
                      }, null, 512), [
                        [_vModelText, email.value]
                      ])
                    ]),
                    (error.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: loading.value || !email.value,
                      class: "otp-btn"
                    }, _toDisplayString(loading.value ? 'Wird gesendet…' : 'Anmelden'), 9, _hoisted_10)
                  ], 40, _hoisted_6))
                : (step.value === 'otp')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "otp-form",
                      onSubmit: _withModifiers(handleVerifyOtp, ["prevent"])
                    }, [
                      _createElementVNode("p", _hoisted_12, [
                        _createTextVNode(" Wir haben einen Code an "),
                        _createElementVNode("strong", null, _toDisplayString(_unref(maskedEmail)), 1),
                        _createTextVNode(" gesendet. Der Code ist 10 Minuten gültig. ")
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                          id: "otp",
                          ref_key: "otpInputRef",
                          ref: otpInputRef,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otpCode).value = $event)),
                          type: "text",
                          inputmode: "numeric",
                          pattern: "[0-9]{6}",
                          maxlength: "6",
                          autocomplete: "one-time-code",
                          placeholder: "000000",
                          required: "",
                          class: "otp-input"
                        }, null, 512), [
                          [_vModelText, otpCode.value]
                        ])
                      ]),
                      (error.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: loading.value || otpCode.value.length !== 6,
                        class: "otp-btn"
                      }, _toDisplayString(loading.value ? 'Wird überprüft…' : 'Anmelden'), 9, _hoisted_16),
                      _createElementVNode("button", {
                        type: "button",
                        class: "otp-resend",
                        disabled: resendCooldown.value > 0,
                        onClick: handleResend
                      }, _toDisplayString(resendCooldown.value > 0 ? `Erneut senden (${resendCooldown.value}s)` : 'Keinen Code erhalten? Erneut senden'), 9, _hoisted_17),
                      _createElementVNode("button", {
                        type: "button",
                        class: "otp-back",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value = 'email'))
                      }, " ← Andere E-Mail-Adresse ")
                    ], 40, _hoisted_11))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(getUserSession) && !_unref(getUser))
        ? (_openBlock(), _createBlock(UserForm, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})